import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {
  createCategory,
  updateCategory,
  getCategory,
  deleteCategory,
} from "../services/providerService";
import { useFormik } from "formik";
import * as Yup from "yup";
import editicon from "../../images/edit-icon.svg";
import binicon from "../../images/bin-icon.svg";
import Loader from "../../utils/Loader";
import reddelete from "../../images/red-Delete.svg";
import { apiUrl, PORT } from "../../environment";
import "./MediaManagment.css";
import { toast } from "react-toastify";

export default function CategoryListing() {
  const [searchText, setSearchText] = useState("");
  const [selectedSortValue, setSelectedSortValue] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState("");
  const [previewImage, setPreviewImage] = useState(null);
  const [show, setShow] = useState(false);
  const [showViewModel, setShowViewModel] = useState(false);
  const [deleteModelShow, setDeleteModelShow] = useState(false);

  useEffect(() => {
    _getCategoryList();
  }, [page, limit]);

  const _getCategoryList = async (
    sortBy,
    _category = "All",
    searchText = ""
  ) => {
    setLoading(true);
    await getCategory(
      {
        page: page + 1,
        limit,
        category: _category || "All",
        searchKey: searchText,
        sortBy: sortBy,
      },
      (data) => {

        setCategoryList(data || []);
        setLoading(false);

      }
    );
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchText(query);
    if (query.length >= 3 || query.length === 0) {
      _getCategoryList(selectedSortValue, category, query);
    }
  };

  const handleSelect = (eventKey) => {
    setSelectedSortValue(eventKey);
    _getCategoryList(eventKey, category, searchText);
  };

  const handleClose = () => setShow(false);

  const validationSchema = Yup.object().shape({
    category: Yup.string().required("Category is required"),
    categoryIcon: Yup.mixed().required("Icon is required"),
  });
  const formik = useFormik({
    initialValues: {
      _id: null,
      category: "",
      categoryIcon: null,
    },
    validationSchema,
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("category", values.category);
      setLoading(true);
      if (values.categoryIcon) {
        formData.append("categoryIcon", values.categoryIcon);
      }

      try {
        let res;
        if (values._id) {
          res = await updateCategory(values._id, formData);
        } else {
          res = await createCategory(formData);
        }

        setShowViewModel(false);

        formik.setValues({
          _id: "",
          category: "",
          categoryIcon: null,
        });
        formik.resetForm();
        setPreviewImage(null);
        if (res?.status === "SUCCESS") {
          toast.success(res?.message);
          _getCategoryList(selectedSortValue, category, searchText);
          setShow(false);
          setShowViewModel(false);
        } else {
          toast.error(res?.message);
          setShow(false);
        }

        setLoading(false);
      } catch (error) {
        toast.error("Failed!");
        setShow(false);
        setShowViewModel(false);
        setLoading(false);
      }
    },
  });

  const createUpdateCateory = (categoryValue) => {
    formik.setValues({
      _id: categoryValue?._id || "",
      category: categoryValue?.category || "",
      categoryIcon: categoryValue?.categoryIcon || null,
    });
    setShowViewModel(true);
  };

  const handelDeleteModel = (categoryValue) => {
    formik.setValues({
      _id: categoryValue?._id || "",
      category: categoryValue?.category || "",
      categoryIcon: categoryValue?.categoryIcon || null,
    });
    setDeleteModelShow(true);
  };

  const _deleteCategory = async () => {
    await deleteCategory(formik.values._id);
    await _getCategoryList(selectedSortValue, category, searchText);
    setDeleteModelShow(false);
  };

  return (
    <>
      {
        loading && <Loader />
      }
      <div className="add-doctor">
        <Form>
          <Form.Group controlId="searchInput">
            <Form.Control
              type="search"
              aria-label="Search"
              value={searchText}
              onChange={handleSearchChange}
              placeholder="Search  by category..."
            />
          </Form.Group>
        </Form>

        <Button onClick={() => createUpdateCateory()} className="filled-btn">
          Create
        </Button>

        <Dropdown className="patient-info-dropdown " onSelect={handleSelect}>
          <Dropdown.Toggle className="db-dropdown h-100 ">
            {selectedSortValue === ""
              ? "Sort By"
              : selectedSortValue === "name-asc"
                ? "Name A-Z"
                : "Name Z-A"}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="">Default</Dropdown.Item>
            <Dropdown.Item eventKey="name-asc">Name A-Z</Dropdown.Item>
            <Dropdown.Item eventKey="name-dsc">Name Z-A</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="table-responsive dashboard-table">
        <table className="patients-table">
          <thead>
            <tr className="t-row-block">
              <th scope="col">Sr No</th>
              <th scope="col">Category</th>
              <th scope="col">Icon</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {categoryList?.length > 0 ? (
              categoryList?.map((cateory, index) => (
                <tr key={cateory.id || index}>
                  <td scope="row">{++index}</td>
                  <td>{cateory?.category ? cateory?.category : "-"}</td>
                  <td>
                    <div
                      style={{ display: "inline-block", marginRight: "10px" }}
                    >
                      {cateory?.categoryIcon ? (
                        <img
                          src={`${apiUrl}${PORT}/user-service/getimages/${cateory?.categoryIcon}`}
                          alt={`Preview ${cateory?.categoryIcon}`}
                          className="file-preview-image"
                          style={{
                            maxWidth: "100px",
                            maxHeight: "50px",
                            marginRight: "10px",
                          }}
                        />
                      ) : (
                        <span style={{ color: "#ccc", fontSize: "16px" }}>
                          No Preview Available{" "}
                        </span>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      <a
                        className="edit-del-icon eye-edit-del edit-img"
                        onClick={() => {
                          createUpdateCateory(cateory);
                        }}
                      >
                        <img src={editicon} alt="edit" />
                      </a>
                      <a
                        className="edit-del-icon eye-edit-del del-img"
                        onClick={() => handelDeleteModel(cateory)}
                      >
                        <img src={binicon} alt="delete" />
                      </a>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No Category Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal to view survey   */}
      <Modal
        className="survey-model"
        show={showViewModel}
        onHide={handleClose}
        centered
        style={{ borderRadius: "20px" }}
      >
        <Modal.Header
          className="header"
          style={{ borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }}
        >
          <Modal.Title>Create Category </Modal.Title>
          <button
            type="button"
            className="close-btn mr-0"
            onClick={handleClose}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form className="" onSubmit={formik.handleSubmit}>
            <div className="form-control-area ">

              <Form.Group
                className="mb-4 text-start"
                controlId="exampleForm.ControlInputFirstName"
              >
                <Form.Label className="details">
                  Category<span className="asterisk"> *</span>
                </Form.Label>
                <div className="row">
                  <div className="col-12">
                    <Form.Control
                      type="text"
                      placeholder="Enter Category Name"
                      name="category"
                      keyField={"category"}
                      formik={formik}
                      value={formik.values.category}
                      onChange={(e) =>
                        formik.setFieldValue("category", e.target.value)
                      }
                      onBlur={formik.handleBlur}

                    //  value={formik.values.content}
                    />

                    {formik.touched.category && formik.errors.category ? (
                      <div className="text-danger">{formik.errors.category}</div>
                    ) : null}
                  </div>
                </div>
              </Form.Group>

              <Form.Group className="mb-4 text-start">
                <Form.Label className="details">
                  Upload Icon <span className="asterisk"> *</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  name="categoryIcon"
                  isInvalid={
                    formik.touched.categoryIcon &&
                    !!formik.errors.categoryIcon
                  }
                  onChange={(e) => {
                    const file = e.target.files[0];
                    formik.setFieldValue("categoryIcon", file);

                    // Create Object URL for preview
                    if (file) {
                      setPreviewImage(URL.createObjectURL(file));
                    }
                  }}
                  onBlur={formik.handleBlur}
                />


                {formik.touched.categoryIcon && formik.errors.categoryIcon ? (
                  <div className="text-danger">{formik.errors.categoryIcon}</div>
                ) : null}
              </Form.Group>

              {/* Show Image Preview */}
              {previewImage ? (
                <div className="mt-3">
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              ) : formik.values._id ? (
                <img
                  src={`${apiUrl}${PORT}/user-service/getimages/${formik.values.categoryIcon}`}
                  alt={`Preview ${formik.values.categoryIcon}`}
                  className="file-preview-image"
                  style={{ maxWidth: "100px", marginRight: "10px" }}
                />
              ) : (
                <span>No image selected</span>
              )}

              { }
            </div>

            <div className=" = d-flex  gap-4 justify-content-end">
              <Button
                className="btn border-btn btn-no"
                onClick={() => setShowViewModel(false)}
              >
                Cancel
              </Button>

              {formik.values._id ? (
                <Button className="btn dark-btn btn-yes" type="submit">
                  Update
                </Button>
              ) : (
                <Button className="btn dark-btn btn-yes" type="submit">
                  Create
                </Button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* delete patient modal */}
      <Modal
        className="dlt-patient-modal"
        show={deleteModelShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDeleteModelShow(false)}
      >
        <Modal.Body>
          <div className="d-flex justify-content-center mb-3">
            <div className="delete-img">
              <img src={reddelete} alt="img"></img>
            </div>
          </div>
          <h4>Are you sure? </h4>
          <p>You want to detele this category</p>
          <div className="authentication-btns d-flex justify-content-center gap-4">
            <Button
              className="btn border-btn btn-no outlined-btn"
              onClick={() => setDeleteModelShow(false)}
            >
              No
            </Button>
            <Button
              className="btn dark-btn btn-yes"
              onClick={() => _deleteCategory()}
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
